import classNames from "classnames";
import { Typography } from "components/atoms";
import "./index.scss";

interface IProps {
  isSent: boolean;
  message: string;
}

export const OnboardMessageBody = ({ isSent, message }: IProps) => {
  const renderWithLineBreaks = (text: string) => {
    const withLineBreaks = text.replace(/\n/g, "<br/>");

    return withLineBreaks;
  };
  return (
    <div
      className={classNames(
        "message-time-wrapper",
        isSent ? "left-align" : "right-align"
      )}
    >
      <div className="message-timer-container">
        <div className={classNames("message")}>
          <Typography
            variant="h9Book"
            label={renderWithLineBreaks(message)}
            styles="typography-custom-style"
          />
        </div>
        <div className="time">
          <Typography
            label="Today, 5:34 PM"
            variant="h9Book"
            styles="typography-custom-style"
          />
        </div>
      </div>
    </div>
  );
};
